module.exports = __webpack_public_path__ + "static/media/rectangle-portrait.a435ccc3.svg";